import { Component, OnInit } from '@angular/core';
import { LibMenusComponent } from '@pishgamrayan/ng-api-documentation';
import { PageNames } from 'src/app/configs/page-names.enum';
import { EventTypes } from 'src/app/core/constants/event-types';
import { BasePageComponent } from '../../shared/base';
import { BaseIndexModule } from '../../shared/base/modules/base-index.module';

@Component({
  selector: 'app-documents-management',
  templateUrl: './documents-management.component.html',
  imports: [BaseIndexModule, LibMenusComponent],
})
export class DocumentsManagementComponent
  extends BasePageComponent
  implements OnInit
{
  //#region Properties
  pageName = PageNames.documentsManagement;

  //#endregion

  constructor() {
    super();
  }

  initForm(): void {}

  ngOnInit() {
    try {
      super.ngOnInit();
      this.pageConfig.showAddBtn = false;
      this.pageConfig.showRefreshBtn = false;
      this.pageConfig.showAuditBtn = false;
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.infrastructure
      );
    }
  }
}
